import {useNotificationStore} from "@/store/notification"
import usePushNotificationHelper, {NotificationType} from "./pushNotifications"
import {useGlobalEmitter} from "@/helper/emitter";
import {kapitelDateString} from "@/graphql/kapitelTypes";
import {sendUserMessage, setUpAssistant} from "@/helper/chat/chatBL";
import {AInesAssistantType} from "@/graphql/generated/graphql";
import router from "@/router";

let initialized = false

export const init = ()=>{

    const notificationStore = useNotificationStore()
    const pushNotificationHelper = usePushNotificationHelper()

    // so kommen neue notifications rein...
    pushNotificationHelper.onNotificationReceived(({view, props, title, body}:NotificationType)=>{
        notificationStore.pushNotification({
            title:title,
            body:body,
            view:view,
            props:props
        })
    })

    if (initialized) {
        console.warn('duplicate init of notification helper: multiple event listeners attached')
    }
    initialized = true
}


export const emitNotificationNavigation = ({view, props}:NotificationType) => {
    switch (view) {
        case 'CalendarDetail':
            useGlobalEmitter().emit("notification:date:clicked", props.dateId as kapitelDateString)
            break
        case 'MonthKPI':
            useGlobalEmitter().emit("notification:month:clicked", props.monthId as kapitelDateString)
            break
        default:
            throw Error(view + " not a valid notification navigation target.")
    }
}


export const onMonthKPIDetailRequest = async (monthId:kapitelDateString) => {
    await setUpAssistant()
    await sendUserMessage("Zeig mir meine Monatskennzahlen für den "+ monthId + ".", {messageExpertAssistant:AInesAssistantType.KpiAndPayroll, isScriptedContent: true})
    router.push('/chat')
}
